import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import * as React from "react";
export var NotBrandNorRetailerMessage = function NotBrandNorRetailerMessage(_ref) {
  var visible = _ref.visible;
  if (!visible) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "RTbSpK",
    defaultMessage: [{
      "type": 0,
      "value": "If you’re a brand or retailer, please choose one of the options above to get a response within 24 hours. If you’re not a brand or retailer, please email us at external-requests@faire.com."
    }]
  }));
};